import { Helmet } from "react-helmet-async";

const Impressum = () => {
  return (
    <>
      <Helmet>
        <title>Impressum - EIGENHEIMVERRENTUNG</title>
        <meta name="description" content="Impressum und rechtliche Informationen von EIGENHEIMVERRENTUNG - Ihre Experten für Immobilienverrentung, Leibrente, Wohnrecht und Teilverkauf." />
        <meta name="keywords" content="impressum, rechtliche hinweise, eigenheimverrentung, kontakt, datenschutz" />
        
        <meta name="robots" content="noindex, follow" />
        <meta name="googlebot" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-background to-muted/20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto">
            <header className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold text-primary mb-4">
                Impressum
              </h1>
              <div className="w-24 h-1 bg-accent mx-auto rounded-full"></div>
            </header>

            <div className="bg-card rounded-2xl shadow-lg border p-8 md:p-12 space-y-8">
              <div className="space-y-6 text-foreground">
                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Angaben gemäß § 5 TMG</h2>
                  <div className="space-y-1">
                    <p className="font-medium">RPI GmbH</p>
                    <p>Gotthelfstraße 36</p>
                    <p>81677 München</p>
                    <p>Deutschland</p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Kontakt</h2>
                  <div className="space-y-1">
                    <p>Tel.: 08962824646</p>
                    <p>E-Mail: <a href="mailto:info@renteplusimmobilie.de" className="text-accent hover:underline">info@renteplusimmobilie.de</a></p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Registereintrag</h2>
                  <div className="space-y-1">
                    <p>Registergericht: Amtsgericht München</p>
                    <p>Registernummer: HRB253896</p>
                    <p>Geschäftsführer: Boris Hardi</p>
                  </div>
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Umsatzsteuer-ID</h2>
                  <p>Umsatzsteuer-Identifikationsnummer: DE331385572</p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Online-Streitbeilegung</h2>
                  <p>
                    Plattform der EU-Kommission zur Online-Streitbeilegung: 
                    <a 
                      href="https://ec.europa.eu/odr" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-accent hover:underline ml-1"
                    >
                      https://ec.europa.eu/odr
                    </a>
                  </p>
                  <p className="mt-2">
                    Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht verpflichtet, hierzu jedoch bereit.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold mb-3 text-primary">Verantwortlich für den Inhalt</h2>
                  <p>Verantwortliche/r i.S.d. § 18 Abs. 2 MStV:</p>
                  <p>Janine Hardi, Gotthelfstr. 36, 81677 München</p>
                </div>

                <div className="pt-8 border-t">
                  <h2 className="text-xl font-semibold mb-4 text-primary">Jetzt kostenlose Beratung vereinbaren</h2>
                  <p className="text-muted-foreground mb-6">
                    Lassen Sie sich unverbindlich über Ihre Möglichkeiten zur Immobilienverrentung beraten.
                  </p>
                  <a
                    href="https://calendly.com/renteplusimmobilie/20min"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-accent hover:bg-accent/90 text-accent-foreground px-6 py-3 rounded-lg font-medium transition-colors"
                  >
                    Beratungstermin vereinbaren
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Impressum;